export default __webpack_public_path__ + "static/media/happy.d3e6a21e.png";